import { useEffect } from 'react'
import { Gem } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { createNadDebug } from '../../utils/debugLog'
import { formatCredits } from './billingTypes'
import { useActiveWalletBalance } from './useActiveWalletBalance'

const log = createNadDebug('dw:billing-wallet')

export default function ActiveWalletBalance() {
  const { t, i18n } = useTranslation('settings')
  const { wallet, query, balance, label } = useActiveWalletBalance()
  const teamId = wallet.team?.id ?? null
  const kind = wallet.kind
  useEffect(() => {
    log({ event: 'wallet:selected', trace_id: 'billing:wallet', wallet_kind: kind, team_id: teamId })
  }, [kind, teamId])
  return <div>
    <p className="mb-1 text-base text-muted-foreground" data-testid="billing-wallet-label">
      {label}
    </p>
    {!wallet.canViewFinancials ? null : query.isLoading ? (
      <p role="status" className="text-base text-muted-foreground" data-testid="billing-balance-loading">{t('settingsModal.billing.loadingBalance')}</p>
    ) : !query.isError && balance === null && wallet.kind === 'team' ? (
      <p className="text-base text-muted-foreground" data-testid="billing-balance-unfunded">{t('settingsModal.billing.historyEmpty')}</p>
    ) : query.isError || balance === undefined || balance === null || !Number.isSafeInteger(balance) ? (
      <p role="alert" className="text-base text-destructive" data-testid="billing-balance-error">{t('settingsModal.billing.balanceFailed')}</p>
    ) : (
      <div className="flex items-center gap-2 text-xl font-semibold text-foreground" data-testid="billing-balance">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-surface-2"><Gem className="h-5 w-5" aria-hidden="true" strokeWidth={1.5} /></span>
        <span>{t('settingsModal.billing.remaining', { credits: formatCredits(balance, i18n.language) })}</span>
      </div>
    )}
  </div>
}
